import Vue from 'vue';
import Mixin from '../../utils/mixin';
import { i18n } from '../../plugins/i18n';
import EventManager from '../../utils/EventManager.js';
import CompressionHelper from '../../utils/CompressionHelper.js';

const loadState = () => ({
    params: {},
    estimateLoaded: false,
    estimateIndex: 0,
    estimateForms: [],
    estimateRefs: {},
    chgEstimateOption: {},
    prevEstimateOption: {},
    estimateSpines: {},
    estimateOptions: {},
    estimateOptionChanges: {},
    estimateCalculates: {},
    estimateSizeOptions: {},
    $em: EventManager,
    flags: {
        token: null,
        compressed: window.appCompressed,
    },
});
export default {
    namespaced: true,
    state: loadState(),
    getters: {
        getEstmateParams(state) {
            return state.params;
        },
        getOrderID(state) {
            return state.order_id;
        },
        getEstimateLoaded(state) {
            return state.estimateLoaded;
        },
        getEstimateIndex(state) {
            return state.estimateIndex;
        },
        getEstimateForms(state) {
            return state.estimateForms;
        },
        getEstimateSpines(state) {
            return state.estimateSpines;
        },
        getEstimateOptions(state) {
            return state.estimateOptions;
        },
        getEstimateOptionChanges(state) {
            return state.estimateOptionChanges;
        },
        getEstimateCalculates(state) {
            return state.estimateCalculates;
        },
        // `/option` 요청 실패 또는 오류 발생 시 호출됨
        getPrevOption(state) {
            return state.prevEstimateOption;
        },
        getEstimateSizeOptions(state) {
            return state.estimateSizeOptions;
        },
        getChgOption(state) {
            return state.chgEstimateOption;
        },
    },
    mutations: {
        setEstimateLoading(state) {
            state.estimateLoaded = true;
        },
        setEstimateForms(state, data) {
            state.estimateForms = data;
        },
        setChgOption(state, data) {
            state.chgEstimateOption = data;
        },
        setEstimateIndex(state, index) {
            state.estimateIndex = index;
        },
        setEstimateSpines(state, data) {
            state.estimateSpines = _.merge({}, state.estimateSpines, data);
        },
        setEstimateOptions(state, data) {
            // console.log('[Store] setEstimateOptions mutation called with data:', data);
            // product_addon_items는 배열이므로 _.merge 대신 직접 교체
            const { product_addon_items, ...rest } = data;
            state.estimateOptions = _.merge({}, state.estimateOptions, rest, { ___: Math.floor(Date.now() / 1000) });
            if (product_addon_items !== undefined) {
                state.estimateOptions.product_addon_items = product_addon_items;
            }
            // console.log('[Store] estimateOptions after merge:', state.estimateOptions);
            // console.log('[Store] postpress.perforating after merge:', state.estimateOptions?.postpress?.perforating);
            ///////////////
            // if (data) {
            //     for (const [key, val] of Object.entries(data)) {
            //         if (!state.estimateOptions[key]) {
            //             state.estimateOptions[key] = {};
            //         }
            //         state.estimateOptions[key] = Object.assign(state.estimateOptions[key], val);
            //     }
            //     state.estimateOptions = JSON.parse(JSON.stringify(state.estimateOptions));
            // }
        },
        setEstimateOptionChanges(state, data) {
            state.estimateOptionChanges = data;
        },
        setEstimateCalculates(state, data) {
            state.estimateCalculates = data;
        },
        setEstimatePrevOption(state, data) {
            state.prevEstimateOption = data;
        },
        setEstimateSizeOptions(state, data) {
            state.estimateSizeOptions = _.merge({}, data);
        },
    },
    actions: {
        // 이전 요청 취소
        cancelPending({ state }) {
            if (state.flags.token) {
                state.flags.token.abort();
            }
        },

        // 새 요청 token 생성
        createCancelToken({ state }) {
            state.flags.token = new AbortController();
            return state.flags.token;
        },

        async fetchEstimateForms({ state, commit, getters, dispatch }, { slug }) {
            let controller, res, jsonData;

            state.estimateForms = {};
            state.estimateRefs = {};
            state.estimateSpines = {};
            state.estimateOptions = {};
            state.estimateSizeOptions = {};
            state.estimateCalculates = {};

            if (getters.estimateLoaded) return;

            await dispatch('cancelPending');
            controller = await dispatch('createCancelToken');

            try {
                res = await Mixin.methods[state.flags.compressed ? 'compress_call_api' : 'call_api'](
                    'post', //
                    `estimate/${slug}/form`,
                    {
                        params: state.params,
                    },
                    false,
                    controller.signal,
                );
            } catch (e) {
                if (e.name === 'CanceledError' || e.message?.toLowerCase().includes('aborted')) return e;
                return Mixin.methods.snack({ message: `${i18n.t('something_went_wrong')}` });
            }

            if (!res?.data?.success) return;

            jsonData = state.flags.compressed //
                ? CompressionHelper.decompressFromBase64(res.data.ciphertext) //
                : res.data.data;

            commit('setEstimateForms', jsonData);
        },
        async fetchEstimateOptions({ state, commit, dispatch }, { slug }) {
            let controller, res, jsonData, jValidations;

            if (!state.estimateLoaded) return;
            else state.estimateLoaded = false;

            await dispatch('cancelPending');
            controller = await dispatch('createCancelToken');

            // console.log('[Store] fetchEstimateOptions called');
            // console.log('[Store] Sending to backend - slug:', slug);
            // console.log('[Store] Sending to backend - estimateOptions:', state.estimateOptions);
            // console.log('[Store] Sending to backend - postpress:', state.estimateOptions?.postpress);
            // console.log('[Store] Sending to backend - postpress.perforating:', state.estimateOptions?.postpress?.perforating);

            try {
                res = await Mixin.methods[state.flags.compressed ? 'compress_call_api' : 'call_api'](
                    'post', //
                    `estimate/${slug}/option`,
                    {
                        options: state.estimateOptions,
                        path: state.params.path,
                        chg_option: state.chgEstimateOption.name,
                        chg_options: state.chgEstimateOption,
                    },
                    false,
                    controller.signal,
                );

                // console.log('[Store] Backend response received:', res?.data);
            } catch (e) {
                console.error('[Store] fetchEstimateOptions error:', e);
                if (e.name === 'CanceledError' || e.message?.toLowerCase().includes('aborted')) return e;
                return Mixin.methods.snack({ message: `${i18n.t('something_went_wrong')}` });
            }

            if (!res?.data?.success) return;

            jsonData = state.flags.compressed //
                ? CompressionHelper.decompressFromBase64(res.data.ciphertext) //
                : res.data.data;

            // `/option` 유효성 검증 과정에서
            // 문제 있으면 알림 띄우고 이전 값으로 되돌리기
            // 유효성 검증됐으면 `/calculate` 호출
            jValidations = jsonData.validations;
            if (jValidations.validations.length > 0) {
                jValidations.validations.forEach((value, key) => {
                    Vue.prototype.$swal({
                        icon: value.remark ?? 'warning',
                        title: value.title ?? 'Notice',
                        html: value.message?.replace(/\r\n|\n|\\n/g, '<br />') ?? 'Messages',
                    });
                });

                // 지정된 실패 이벤트가 있으면 실행
                if (state.$em.has(jValidations.options?.events?.fail)) {
                    await state.$em.triggerAsync(
                        jValidations.options.events.fail, //
                        jValidations.options,
                    );
                }

                // watch::getPrevOption 감시 정의해둔 곳으로 전부 전파
                commit('setEstimatePrevOption', state.chgEstimateOption);
            } else {
                // 지정된 완료 이벤트가 있으면 실행
                if (state.$em.has(jValidations.options?.events?.done)) {
                    await state.$em.triggerAsync(
                        jValidations.options.events.done, //
                        jValidations.options,
                    );
                }

                // watch::getEstimateOptionChanges 감시 정의해둔 곳으로 전부 전파
                commit('setEstimateOptionChanges', jsonData);
                // 현재 견적 구성으로 계산 실행
                dispatch('fetchCalculateEstimate', { slug: slug });
            }
        },

        async fetchCalculateEstimate({ state, commit, getters, dispatch }, { slug }) {
            let controller, res, jsonData, jValidations;

            await dispatch('cancelPending');
            controller = await dispatch('createCancelToken');

            try {
                res = await Mixin.methods[state.flags.compressed ? 'compress_call_api' : 'call_api'](
                    'post', //
                    `estimate/${slug}/calculate`,
                    {
                        path: state.params.path,
                        order_id: state.params.order_id,
                        options: state.estimateOptions,
                    },
                    false,
                    controller.signal,
                );
            } catch (e) {
                if (e.name === 'CanceledError' || e.message?.toLowerCase().includes('aborted')) return e;
                return Mixin.methods.snack({ message: `${i18n.t('something_went_wrong')}` });
            }

            if (!res?.data?.success) return;

            jsonData = state.flags.compressed //
                ? CompressionHelper.decompressFromBase64(res.data.ciphertext) //
                : res.data.data;

            commit('setEstimateCalculates', jsonData);
            dispatch('brodcastCalculateEstimate', { data: jsonData });
        },

        //견적수정(주문번호로)
        async modifyEstimateOption(
            { commit, getters, dispatch },
            { order_id, order_detail_id, supply_price, estimate_options, product_options, calculate_options, modify_content, modify_user_id },
        ) {
            let formData = new FormData();
            formData.append('order_id', order_id);
            formData.append('order_detail_id', order_detail_id);
            formData.append('supply_price', supply_price);

            let send_estimate_options = JSON.stringify(estimate_options);
            //send_estimate_options = pako.deflate(send_estimate_options,{level:9});
            let send_product_options = JSON.stringify(product_options);
            let send_calculate_options = JSON.stringify(calculate_options);

            formData.append('estimate_options', send_estimate_options);
            formData.append('product_options', send_product_options);
            formData.append('calculate_options', send_calculate_options);
            formData.append('modify_content', modify_content);
            formData.append('modify_user_id', modify_user_id);

            /*
            var jsonData = { "key1": "value1", "key2": "value2" };
            var jsonString = JSON.stringify(jsonData);
            var compressedData = pako.gzip(jsonString, { to: 'Uint8Array' });
            // console.log('gzip', compressedData);
            let original_str = pako.ungzip(compressedData, { to: 'Uint8Array' });
            // console.log('unzip',original_str);
            formData.append('estimate_options',compressedData);
            */

            //formData.append('estimate_options',pako.gzip('test data',{ to: 'string' }));
            //formData.append('product_options',JSON.stringify(product_options));
            //formData.append('calculate_options',JSON.stringify(calculate_options));

            const res = await Mixin.methods.call_api('post', `estimate/modify`, formData, true);

            if (res?.data?.success) {
                //alert(res.data.message);
                window.parent.postMessage({ path: 'estimate_modify', data: res.data }, window.shopSetting.appUrl);

                //commit("addToCart", res.data.data);
                //commit("updateCartShops", res?.data?.shop);

                //dispatch("proccessCoupon");
            }

            return res;
        },

        async brodcastCalculateEstimate({ state, commit, getters, dispatch }, { data }) {},
        setItemConfig({ getters }, { item_id, part }) {
            window.parent.postMessage({ path: 'admin', item_id: item_id, part: part }, window.shopSetting.appUrl);
        },
    },
};
